import * as React from 'react';
import { IStore } from 'redux/IStore';
import { resetErrorMessage } from 'redux/modules/error';
import { IErrorDataAction } from 'models/error';
import { ErrorPage } from 'containers';
const { connect } = require('react-redux');

interface IProps {
	message: any;
	location?: any;

	/* function props */
	resetErrorMessage: () => IErrorDataAction;
}

@connect(
	(store: IStore) => ({ message: store.error.message }),
	(dispatch) => ({
		resetErrorMessage: () => dispatch(resetErrorMessage()),
	}),
)
class Error extends React.Component<IProps, {}> {
	constructor(props: IProps) {
		super(props);
	}

	public componentWillUnmount() {
		this.props.resetErrorMessage();
	}

	public render() {
		const { message, location } = this.props;

		if (!message) {
			return null;
		}

		return <ErrorPage location={location} message={message} />;
	}
}

export { Error };
